import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, useNavigate } from 'react-router-dom'
import Divider from '@mui/material/Divider';
import profile from '../assets/user.png'
import Avatar from '@mui/material/Avatar';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import config from '../config.json'

import axios from "axios"

import { Cookies } from 'react-cookie';

import {
    Backdrop,
    CircularProgress,
} from "@mui/material";

import { toast, ToastContainer } from "react-toastify";


const cookies = new Cookies();

const BASE_URL = config.SERVER_URL;

export default function Navbar(props) {


    const [backdropopen, setbackdropopen] = useState(false);

    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();

        setbackdropopen(true)

        axios.post(BASE_URL+"/auth/logout",
            {}, { withCredentials: true }
        )
            .then(response => {
                if (response.status == 200) {

                    setbackdropopen(false)

                    toast.success("Logged Out Successfully", {
                        position: "bottom-center",
                    });

                    cookies.remove("sessionid")
                    sessionStorage.removeItem("sessionid")
                    navigate('/')
                } else {
                    setbackdropopen(false)

                    toast.error("Something Went Wrong", {
                        position: "bottom-center",
                    });

                }



            })
            .catch(error => {
                setbackdropopen(false)
                toast.error("Something Went Wrong", {
                    position: "bottom-center",
                });
            });



    }

    return (
        <>
            <nav className="navbar  navbar-expand-lg " >

                <div className="container-fluid" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>

                    <div>
                        <h4 className='rubik-font' style={{ fontWeight: "lighter" }}>{props.title}</h4>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h4 className='rubik-font' style={{ fontWeight: "lighter", textAlign: 'center' }}>{props.name} &nbsp;</h4>
                        {/* <Divider orientation='vertical' flexItem={true}></Divider> &nbsp; */}
                        <h4 style={{ fontWeight: "lighter", textAlign: 'center' }}>| &nbsp;</h4>
                        <h4 className='rubik-font' style={{ fontWeight: "lighter", textAlign: 'center' }}>{props.role}</h4>
                        <div className="nav-item dropdown " data-bs-toggle="dropdown" id="navbarDropdown">
                            <a className="nav-link" href='#'>
                                <img src={profile} style={{ width: '50px', alignItems: "center" }}></img>
                                {/* <i class="fas fa-user-shield"></i> */}
                                {/* <FontAwesomeIcon icon="fas fa-user-shield" /> */}

                            </a>
                            <div className="center dropdown-menu dropdown-menu-lg dropdown-menu-end" >
                                <div className="center1">
                                    {/* <img src={profile} style={{ width: "200px" }} alt="profile" /> */}
                                    <Avatar
                                        src={profile}
                                        sx={{ width: 50, height: 50 }}
                                        variant="circle"
                                        style={{ alignItems: 'center' }} />
                                </div>
                                {/* <a href="/collector_profile/" className="dropdown-item " style={{ alignItems: "center" }}>
                                        <FontAwesomeIcon icon={faUserEdit} /> Update Profile
                                    </a> */}
                                <a href="/logout" className="dropdown-item" onClick={handleClick}>
                                    <PowerSettingsNewIcon /> Logout
                                </a>

                            </div>
                        </div>

                    </div>


                </div>
            </nav>
            {/* <nav className="user navbar navbar-expand-lg  text-center p-3">
                <div className="container-fluid ">
                    <div className="collapse navbar-collapse " id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" aria-current="page" to="/strainrepositoryView">Strains</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" aria-current="page" to="/enterStrain">Enter Strain</Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav> */}

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropopen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ToastContainer />

        </>
    )
}
